import { pixelConfigs } from '@/utils/pixelConfig'

function sendEventWithDelay(eventName) {
  if (!window.fbq) {
    console.warn('fbq not loaded')
    return
  }

  pixelConfigs.forEach((cfg, index) => {
    // 每筆事件延遲 150ms，避免短時間大量請求 429
    setTimeout(() => {
      window.fbq('track', eventName, {}, { eventID: cfg.eventID })
      // console.log(`[Pixel] Sent ${eventName} for Pixel ID ${cfg.id} with eventID ${cfg.eventID}`)
    }, index * 150)
  })
}

// 註冊成功事件
export function sendRegisterEvent() {
  sendEventWithDelay('CompleteRegistration')
}

// 首存成功事件
export function sendFirstPurchaseEvent() {
  sendEventWithDelay('Purchase')
}
